import React, { useState } from 'react';
import { Row, Spin, VertButton, VertModal } from '@vertem-core/vertice-ds';
import { LoadingOutlined } from '@ant-design/icons';
import PreviewPDF from 'components/PreviewPDF';
import { useTheme } from 'services/ThemeService';

interface AcceptTermsModalProps {
  visible?: boolean;
  onClose: () => void;
  onAgree: () => void;
  urlPDF: string,
  title?: string;
  message?: string;
}

const AcceptTermsModal = ({
                            visible=false,
                            urlPDF='',
                            title = 'Termos de uso',
                            message = 'Li e aceito o regulamento da campanha.',
                            onAgree,
                            onClose
                          }: AcceptTermsModalProps) => {
  
  const [isLoadingButton, setLoadingButton] = useState(false);
  const [isLoadingContent, setLoadingContent] = useState(false);
  const { theme } = useTheme();
  
  const highlightColor = theme?.token?.colorPrimary ||
    theme?.designTokens?.['color-highlight'] ||
    '#6b6c72';
  
  React.useEffect(() => {
    if (visible) {
      document.body.style.overflow = 'hidden';
      setLoadingContent(true);
      
      const timer = setTimeout(() => {
        setLoadingContent(false);
      }, 2000);
      
      return () => {
        clearTimeout(timer);
        document.body.style.overflow = 'unset';
      };
    }
      document.body.style.overflow = 'unset';
    
  }, [visible]);
  
  const CheckProtocol = (url: any) => {
    const hasHttp = url.startsWith('http://');
    const hasHttps = url.startsWith('https://');
    
    if (hasHttp || hasHttps) {
      return url;
    }
    
    return `https://s3.amazonaws.com/${url}`;
  };
  
  const handleAgree = () => {
    setLoadingButton(true);
    
    setTimeout(() => {
      onAgree();
      setLoadingButton(false);
    }, 500);
  };
  
  return (
    <VertModal
      open={visible}
      maskClosable={false}
      onCancel={() => {
        if (onClose) {
          onClose();
        }
      }}
      width="96%"
      style={{
        maxWidth: '900px',
        height: 'calc(100vh - 20px)',
        top: 0,
        padding: 0,
        margin: 0
      }}
      bodyStyle={{
        height: 'calc(100vh - 100px)',
        padding: 24,
        display: 'flex',
        flexDirection: 'column'
      }}
      className='pwa-modal'
    >
      <Row
        gutter={10}
        className="padding-x-regular padding-y-regular"
        style={{
          flex: 1,
          display: 'flex',
          flexDirection: 'column',
          height: '100%'
        }}
      >
        <div
          style={{
            width: '100%',
            height: '100%',
            display: 'flex',
            flexDirection: 'column'
          }}
        >
          <div
            className="regulations-collapse-container"
            style={{
              flex: 1,
              minHeight: 0,
              position: 'relative',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center'
            }}
          >
            {isLoadingContent ? (
              <div style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                height: '100%',
                width: '100%'
              }}>
                <Spin
                  size="large"
                  indicator={<LoadingOutlined style={{ fontSize: 48, color: highlightColor }} spin />}
                />
              </div>
            ) : (
              <div
                className="regulation-list"
                style={{
                  height: '100%',
                  width: '100%'
                }}
              >
                <PreviewPDF urlPDF={CheckProtocol(urlPDF)} />
              </div>
            )}
          </div>
          
          <VertButton
            style={{ width: '100%', marginTop: '16px' }}
            disabled={isLoadingButton || isLoadingContent}
            onClick={handleAgree}
            className='pwa-button pwa-button-outline'
          >
            {isLoadingButton ? <Spin /> : message}
          </VertButton>
        </div>
      </Row>
    </VertModal>
  );
};

export default AcceptTermsModal;
